<template lang="html">
    <div class="aside-notifs">
        <div class="loader" v-if="loading">
            <img src="../../assets/img/grid_loader.svg" />
        </div>
        <!-- new notifications -->
        <v-list class="notif" v-if="notifs && notifs.length > 0 && !loading">
            <p>Nouvelles Notifications</p>
            <!-- list of new notifs -- on click mark as read & go to the product -->
            <v-list-tile v-for="(notif,index) in notifs" :key="notif.id" @click="markAsRead(notif.id,notif.data.product,notif.type,index)" class="li">
                <avatar :item="notif.data.product" size="4rem"></avatar>
                <v-list-tile-content>
                    <v-list-tile-title v-if="notif.type.includes('Test')">Un contrôle effectué par : <span>{{notif.data.user.first_name}} {{notif.data.user.last_name}}</span>
                        <template v-if="notif.data.status == 'failed'">a <span class="status">{{$_.find(TestStatuses,ts => ts.value == notif.data.status).label}}</span></template>
                        <template v-if="notif.data.status == 'finished'">est <span class="status">{{$_.find(TestStatuses,ts => ts.value == notif.data.status).label}}</span></template>
                        sur le produit : <span>{{notif.data.product.label}}</span></v-list-tile-title>
                    <v-list-tile-sub-title>{{moment(notif.created_at).calendar()}}</v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
        <!-- old ones  -->
        <v-list class="notif" v-if="Olds && Olds.length > 0 && !loading">
            <p>Anciennes Notifications</p>
            <!-- list of last 20 notifs -- click go to the item  -->
            <v-list-tile v-for="(notif,index) in Olds" :key="notif.id" @click="go(notif.data.product,notif.type)" class="li">
                <avatar :item="notif.data.product" size="4rem"></avatar>
                <v-list-tile-content>
                    <v-list-tile-title v-if="notif.type.includes('Test')">Un contrôle effectué par : <span>{{notif.data.user.first_name}} {{notif.data.user.last_name}}</span>
                        <template v-if="notif.data.status == 'failed'">a <span class="status">{{$_.find(TestStatuses,ts => ts.value == notif.data.status).label}}</span></template>
                        <template v-if="notif.data.status == 'finished'">est <span class="status">{{$_.find(TestStatuses,ts => ts.value == notif.data.status).label}}</span></template>
                        sur le produit :
                        <span>{{notif.data.product.label}}</span></v-list-tile-title>
                    <v-list-tile-sub-title>Lu : {{moment(notif.read_at).calendar()}}</v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </div>
</template>

<script>
    import Avatar from '../avatar/Avatar.vue'
    import {TestStatuses} from '../../config/enum/TestStatuses'
    import moment from 'moment'
    moment.locale('fr')

    export default {
        components: { Avatar },
        data() {
            return {
                title:  'Notifications',
                icon:   'notifications',
                notifs: [],
                moment,
                Olds : [],
                TestStatuses,
                loading: false,
            }
        },

        methods: {
            // on click on new notif
            markAsRead(id,item,type,index){
                this.axios.post(`/api/notification/read`,{id:id})
                .then(response => {
                    this.notifs.splice(index,1)
                    this.$eventHub.$emit('update-notifs')
                    this.go(item,type)

                })
            },
            go(item,type){
                this.$eventHub.$emit('close-aside')
                if(type.includes('Test')) {
                    this.$router.push({name:'single-product', params:{super_family:item.group , id:item.id}})
                }
            },
            // method to get all new notifs
            getNotifs() {
                this.loading = true
                this.axios.get(`/api/notification/get`)
                .then(response => {
                    this.notifs = response.data
                    this.$eventHub.$emit('update-total',this.notifs.length)
                    this.loading = false
                })
            },
            // method to get all olds notifs
            getOld() {
                this.axios.get(`/api/notification/getold`)
                .then(response => {
                    this.Olds = response.data
                    this.Olds = this.$_.orderBy(this.Olds, 'read_at', 'desc')
                })
            }
        },
        created() {
            // Bus to get all notifs (old and new)
            this.$eventHub.$on('get-notifications',() => {
                this.getNotifs()
                this.getOld()
            })
        },
        mounted(){
            this.getNotifs()
            this.getOld()
        }
    }
</script>

<style lang="stylus" scoped>
@require '../../assets/css/variables'
.aside-notifs {
    overflow-y: scroll
    height: 100%
    .loader {
        display: flex
        align-items: center
        justify-content: center;
        height: 100%
    }
    .notif {
        p {
            font-size: 1.5rem
            font-weight: bold
            margin-top: 2rem
            margin-bottom: 4rem
            padding-left: 2rem
        }
        .li {
            display: flex
            flex-direction: column
            padding-bottom: 1rem
            border-bottom: 1px solid $border-light-color
            & >>> a.list__tile{
                height: 100%
                display: flex
                flex-direction: row
                align-items: center
                justify-content: flex-start
                // div.avatar {
                //     width: 4rem
                //     height: 4rem
                //     border-radius: 50%
                //     display: flex
                //     align-items: center
                //     justify-content: center
                //     min-width: 4rem!important
                // }
            }
            margin-bottom: 2rem
        }

        .list__tile__content {
            font-size: 1.4rem

            .list__tile__title {
                font-weight: 500
                white-space: normal
                word-break: break-word
                line-height: 1.7rem
                height: auto
                span {
                    font-weight: 600
                    &.status {
                        color: $primary-color
                    }
                }
            }
            .list__tile__sub-title{
                margin-top:1rem
                color: $primary-color
                font-weight: 500
                font-size: inherit
                font-size: 1.4rem
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/aside/Notifications.vue